module.exports = __webpack_public_path__ + "img/reorient-ic.db756970.svg";